<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        <Spinner v-if="isLoading"/>
        <div v-else-if="!isLoading && locationData" :class="{'datatable-is-loading':locationIsLoading}">
          <Toolbar class="p-mb-4 p-p-2 page-toolbar">
            <template #start>
              <div style="font-size: 1.4em; color: inherit" class="p-p-2">{{ $t('Location') }}: {{locationData.public_name}}</div>
            </template>
            <template #end>
              <div class="p-p-1">
                <Button v-if="$store.getters.isAdminOrHigher" :disabled="!$store.getters.isAdminOrHigher || disableEditButton || locationIsLoading"
                        :loading="locationIsLoading"
                        :label="$t('Edit')"
                        icon="ti-pencil"
                        @click="editItem"
                        class="p-button-success p-button-raised"/>
              </div>
            </template>
          </Toolbar>

          <div class="p-fieldset p-p-1 p-mt-3 p-mb-3">
            <div class="p-grid p-p-0 p-m-0">
              <div class="p-col-12 p-sm-12 p-md-12 p-lg-12" v-if="$store.state.mobileLayout || $store.state.tabletLayout">
                <table>
                  <tbody style="text-align: left">
                  <tr>
                    <th class="p-p-1">{{ $t('Address') }}:</th>
                    <td class="p-p-1">
                      <div class="p-ml-3">
                        <div v-if="addressLine()">
                          <span>{{ addressLine() }}</span>
                        </div>
                        <i v-else class="ti-minus"></i>
                      </div>
                    </td>
                  </tr>
                  <!--                  Dont delete!!-->
                  <!--                  <tr>-->
                  <!--                    <th class="p-p-1">{{ $t('Country') }}:</th>-->
                  <!--                    <td class="p-p-1">-->
                  <!--                      <div class="p-ml-3">-->
                  <!--                        <template v-if="locationData.country_name">{{ locationData.country_name }}</template>-->
                  <!--                        <i v-else class="ti-minus"></i>-->
                  <!--                      </div>-->
                  <!--                    </td>-->
                  <!--                  </tr>-->
                  <tr>
                    <th class="p-p-1">{{ $t('Company') }}:</th>
                    <td class="p-p-1">
                      <div class="p-ml-3">
                        <template v-if="locationData.company_name">{{ locationData.company_name }} <span v-if="locationData.company_reg_number"> ({{ locationData.company_reg_number }})</span></template>
                        <i v-else class="ti-minus"></i>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="p-p-1">{{ $t('Short Name') }}:</th>
                    <td class="p-p-1">
                      <div class="p-ml-3">
                        <template v-if="locationData.slug">{{ locationData.slug }}</template>
                        <i v-else class="ti-minus"></i>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="p-p-1">{{ $t('Email') }}:</th>
                    <td class="p-p-1">
                      <div class="p-ml-3">
                        <template v-if="locationData.email">{{ locationData.email }}</template>
                        <i v-else class="ti-minus"></i>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th class="p-p-1">{{ $t('Phone') }}:</th>
                    <td class="p-p-1">
                      <div class="p-ml-3">
                        <span v-if="locationData.phone_code && locationData.phone_number">+{{ locationData.phone_code }} {{ locationData.phone_number }}</span>
                        <i v-else class="ti-minus"></i>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <th class="p-p-1">{{$t('Created')}}:</th>
                    <td class="p-p-1">
                      <div class="p-ml-3">
                        <template v-if="locationData.created_at">
                          {{ formatBy(locationData.created_at, locationData.creator) }}
                        </template>
                        <i v-else class="ti-minus"></i>
                      </div>
                    </td>
                  </tr>
                  <!--                  Dont delete!!-->
                  <!--                  <tr>-->
                  <!--                    <th class="p-p-1">{{$t('Updated')}}:</th>-->
                  <!--                    <td class="p-p-1">-->
                  <!--                      <div class="p-ml-3">-->
                  <!--                          <span v-if="locationData.updated_at">-->
                  <!--&lt;!&ndash;                            <template v-if="$store.getters.isSuperAdmin">{{ formatBy(locationData.created_at, locationData.creator) }}</template>&ndash;&gt;-->
                  <!--&lt;!&ndash;                            <template v-else>{{ formatDate(locationData.created_at) }}</template>&ndash;&gt;-->
                  <!--                            {{ formatDate(locationData.updated_at) }}-->
                  <!--                          </span>-->
                  <!--                        <i v-else class="ti-minus"></i>-->
                  <!--                      </div>-->
                  <!--                    </td>-->
                  <!--                  </tr>-->
                  </tbody>
                </table>
              </div>
              <template v-else>
                <div class="p-col-12 p-sm-12 p-md-12 p-lg-6">
                  <table>
                    <tbody style="text-align: left">
                    <tr>
                      <th class="p-p-1">{{ $t('Address') }}:</th>
                      <td class="p-p-1">
                        <div class="p-ml-3">
                          <div v-if="addressLine()">
                            <span>{{ addressLine() }}</span>
                          </div>
                          <i v-else class="ti-minus"/>
                        </div>
                      </td>
                    </tr>
                    <!--                  Dont delete!!-->
                    <!--                    <tr>-->
                    <!--                      <th class="p-p-1">{{ $t('Country') }}:</th>-->
                    <!--                      <td class="p-p-1">-->
                    <!--                        <div class="p-ml-3">-->
                    <!--                          <template v-if="locationData.country_name">{{ locationData.country_name }}</template>-->
                    <!--                          <i v-else class="ti-minus"></i>-->
                    <!--                        </div>-->
                    <!--                      </td>-->
                    <!--                    </tr>-->
                    <tr>
                      <th class="p-p-1">{{ $t('Company') }}:</th>
                      <td class="p-p-1">
                        <div class="p-ml-3">
                          <template v-if="locationData.company_name">{{ locationData.company_name }} <span v-if="locationData.company_reg_number"> ({{ locationData.company_reg_number }})</span></template>
                          <i v-else class="ti-minus"/>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th class="p-p-1">{{ $t('Short Name') }}:</th>
                      <td class="p-p-1">
                        <div class="p-ml-3">
                          <template v-if="locationData.slug">{{ locationData.slug }}</template>
                          <i v-else class="ti-minus"/>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div class="p-col-12 p-sm-12 p-md-12 p-lg-6">
                  <table>
                    <tbody style="text-align: left">
                    <tr>
                      <th class="p-p-1">{{ $t('Email') }}:</th>
                      <td class="p-p-1">
                        <div class="p-ml-3">
                          <template v-if="locationData.email">{{ locationData.email }}</template>
                          <i v-else class="ti-minus"/>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th class="p-p-1">{{ $t('Phone') }}:</th>
                      <td class="p-p-1">
                        <div class="p-ml-3">
                          <span v-if="locationData.phone_code && locationData.phone_number">+{{ locationData.phone_code }} {{ locationData.phone_number }}</span>
                          <i v-else class="ti-minus"/>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th class="p-p-1">{{$t('Created')}}:</th>
                      <td class="p-p-1">
                        <div class="p-ml-3">
                          <template v-if="locationData.created_at">
                            {{ formatBy(locationData.created_at, locationData.creator) }}
                          </template>
                          <i v-else class="ti-minus"/>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

              </template>
            </div>
          </div>

          <TabMenu :model="tabMenuItems" class="p-p-1"/>

          <router-view :key="locationData.id" :locationData="locationData"
                       :locationIsLoading="locationIsLoading"
                       @update-items="updateItems"/>

          <LocationModal v-if="$store.getters.isAdminOrHigher" :visible="itemModal"
                         :item="item"
                         @update-items="updateItems"
                         @close="closeItemModal"/>
        </div>
        <div v-else-if="!isLoading && !locationData" class="empty-page">{{ $t('No data available') }}</div>
      </div>

    </div>
  </div>
</template>

<script>
import httpClient from '@/services/http.services'
import settings from '@/settings.js'
import constants from '@/constants'
import httpMixins from '@/mixins/httpMixins'
import showErrorsMixins from "@/mixins/showErrorsMixins";
import datatableMixins from "@/mixins/datatableMixins";
import formatMixins from "@/mixins/formatMixins";
import LocationModal from "@/pages/account/components/LocationModal";

export default {
  components: { LocationModal },
  mixins: [ httpMixins, showErrorsMixins, datatableMixins, formatMixins ],
  data() {
    return {
      // selectedCustomer: { id: null },
      disableEditButton: false,
      locationIsLoading: false,
      itemModal: false,
      item: {},
      // taxes: null,
      userId: null,
      isLoading: true,
      locationData: null,
      settings,
      tabMenuItems: [],
      constants
    }
  },
  created() {
    if (!this._abortors) this._abortors = {}
  },
  watch: {
    '$route.params.slug'(newVal, oldVal) {
      if (String(newVal || '') !== String(oldVal || '')) {
        this.getPageData()
      }
    },
    '$i18n.locale'() {
      if (this.locationData) {
        this.getTabMenu()
      }
    },
    '$store.state.firstLayerIsOpened'() {
      if (!this.$store.state.firstLayerIsOpened) {
        if (this.itemModal) {
          this.closeItemModal()
        }
        if (this.confirmItemDeleteModal) {
          this.closeConfirmItemDeleteModal()
        }
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0)
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.ensureAllowedSettingsTab()
    this.getPageData()
  },
  methods: {
    ensureAllowedSettingsTab() {
      if (!this.$store.getters.isAccountant) return

      const allowedRoutes = [
        'LocationSettingsGeneral',
        'LocationSettingsAccounting',
        'LocationSettingsDocuments',
        'LocationSettingsMarkup',
      ]

      if (!allowedRoutes.includes(this.$route.name)) {
        this.$router.replace({
          name: 'LocationSettingsGeneral',
          params: this.$route.params,
          query: this.$route.query,
          hash: this.$route.hash,
        })
      }
    },
    addressLine() {
      // подставь свои поля
      const item = this.locationData
      const parts = [
        item.address1,
        item.address2,
        item.city,
        item.region,
        item.postcode,
        item.country,
        item.country_name
      ].filter(Boolean)

      return parts.join(', ')
    },
    getPageData() {
      this.getLocationData()
    },
    editItem() {
      if (!this.$store.getters.isAdminOrHigher) return
      if (this.locationData) {
        this.item = this.locationData
        this.itemModal = true
        this.$store.commit('toggleFirstLayer', true)
      }
    },
    async updateItems() {
      await this.getLocationData(false)

      // Полные данные остаются только в this.locationData.
      // В global store для текущей локации перечитываем только компактный context.
      if (+this.locationData?.id === +this.$store.getters.locationId) {
        await this.$store.dispatch('reloadCurrentContextData')
      }
    },
    closeItemModal() {
      this.itemModal = false
      if (this.$store.state.firstLayerIsOpened === true ) {
        this.$store.commit('toggleFirstLayer', false)
      }
      this.item = {}
      this.submitted = false
    },
    getTabMenu() {
      const base = this.getLocationBasePath()

      this.tabMenuItems = [
        { label: this.$t('General'),               to: `${base}/general` },
        { label: this.$t('Working Hours'),         to: `${base}/hours` },
        { label: this.$t('estimateBookingTitle'),        to: `${base}/booking` },
        { label: this.$t('priceRequestFormTab'),   to: `${base}/price-request` },
        { label: this.$t('locationAccountingTitle'), to: `${base}/accounting` },
        { label: this.$t('Documents'),             to: `${base}/documents` },
        // { label: this.$t('Documents & Numbering'), to: `${base}/documents` },
        { label: this.$t('Markups'),               to: `${base}/markup` },
        { label: this.$t('Branding'),              to: `${base}/branding` },
        { label: this.$t('Notifications'),         to: `${base}/notifications` },
      ].filter(item => this.$store.getters.isAdminOrHigher ||
          ['general', 'accounting', 'documents', 'markup'].includes(item.to.split('/').pop()))

      // At this point user/tenant data is loaded, so Vuex is the authoritative
      // source of the effective role even if the early router redirect ran first.
      this.ensureAllowedSettingsTab()
    },
    // getEffectiveLocationId() {
    //   if (this.$route.params?.id) {
    //     const rid = this.$route.params.id
    //     return rid ? Number(rid) : null
    //   }
    //
    //   const cid = this.$store.getters.locationId
    //   return cid ? Number(cid) : null
    // },

    getLocationPayload() {
      const slug = this.$route.params?.slug

      if (slug) {
        return { slug }
      }

      const id = this.$store.getters.locationId
      return id ? { id: Number(id) } : null
    },

    getLocationBasePath() {
      const slug = this.$route.params?.slug

      return slug ? `/location-settings/${slug}` : '/location-settings'
    },

    async getLocationData(showSpinner = true) {
      const payload = this.getLocationPayload()

      if (!payload) {
        this.isLoading = false
        return
      }

      if (!this.userCanGetData || this.locationIsLoading) return

      this.isLoading = showSpinner
      this.locationIsLoading = true

      const ctrl = this.setController?.('locationData')

      try {
        const { status, data } = await httpClient({
          url: 'location/get-data?expand=country_name',
          method: 'post',
          data: payload,
          signal: ctrl?.signal
        })

        if (status === 200 && data?.success && data.location) {
          this.locationData = {
            ...data.location,
            accounting_period_lock_available: (data.entitlements?.features || []).includes('period_lock'),
            price_request_form_available: (data.entitlements?.features || []).includes('price_request_form'),
            accounting_export_available: (data.entitlements?.features || []).includes('accounting_export'),
            purchase_invoices_available: (data.entitlements?.features || []).includes('purchase_invoices'),
          }

          if (data.location.creator_first_name || data.location.creator_last_name) {
            this.locationData.creator = {
              first_name: data.location.creator_first_name,
              last_name: data.location.creator_last_name,
              role: data.location.creator_role,
            }
          }

          this.getTabMenu()
        } else {
          this.showUnknownError()
          this.locationData = null
        }
      } catch (err) {
        this.showError(err)
      } finally {
        this.disableEditButton = false
        this.locationIsLoading = false
        this.isLoading = false

        if (this._abortors?.locationData === ctrl) {
          this._abortors.locationData = null
        }
      }
    },
  },
}
</script>
